module.exports = __webpack_public_path__ + "static/media/blogg.d2743756.jpeg";